import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { TeamDeskLinkedService } from 'app/model/linkedservice/team-desk.linkedservice';
import { AdapterRegistry, IModel, Metamodel, RestBasedServiceAuthenticationType } from 'shell-models-lib';
import { Model } from 'app/model/backendmodel';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TeamDeskLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                apiToken: 'secret'
            },
            parameters: '*'
        }
    }
})
export class TeamDeskLinkedServiceAdapter extends LinkedServiceAdapter<TeamDeskLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => TeamDeskLinkedService {
        return TeamDeskLinkedService;
    }

    protected model(): IModel {
        return TeamDeskLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: TeamDeskLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.TeamDeskLinkedService;
        properties.type = Metamodel.modelFor(TeamDeskLinkedService).name;
        if (linkedService.authenticationType === RestBasedServiceAuthenticationType.BASIC) {
            properties.typeProperties = {
                url: this.valueToResource(linkedService, TeamDeskLinkedService.URL),
                authenticationType: linkedService.authenticationType,
                userName: this.valueToResource(linkedService, TeamDeskLinkedService.USER_NAME),
                password: parameterizablePasswordOrAKVtoSecretBase(linkedService, TeamDeskLinkedService.PASSWORD, this.context)
            };
        } else if (linkedService.authenticationType === RestBasedServiceAuthenticationType.TOKEN) {
            properties.typeProperties = {
                url: this.valueToResource(linkedService, TeamDeskLinkedService.URL),
                authenticationType: linkedService.authenticationType,
                apiToken: parameterizablePasswordOrAKVtoSecretBase(linkedService, TeamDeskLinkedService.API_TOKEN, this.context)
            };
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: TeamDeskLinkedService): Promise<TeamDeskLinkedService> {
        const properties = linkedServiceResource.properties as Model.TeamDeskLinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(linkedService, TeamDeskLinkedService.URL, typeProperties.url);
        linkedService.authenticationType = typeProperties.authenticationType as RestBasedServiceAuthenticationType;
        if (linkedService.authenticationType === RestBasedServiceAuthenticationType.BASIC) {
            ValueAdapter.toModel(linkedService, TeamDeskLinkedService.USER_NAME, typeProperties.userName);
            parameterizableSecretBaseToModel(linkedService, TeamDeskLinkedService.PASSWORD, typeProperties.password, this.context);
        } else if (linkedService.authenticationType === RestBasedServiceAuthenticationType.TOKEN) {
            parameterizableSecretBaseToModel(linkedService, TeamDeskLinkedService.API_TOKEN, typeProperties.apiToken, this.context);
        }
        return linkedService;
    }
}
